<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@ds/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <!--
    A `<p>`, not the registry's `<h5>`: a callout beside a field is not a
    section of the document, and a heading here would land in the outline
    between the step's own heading and its fields.
  -->
  <p :class="cn('text-sm font-bold leading-snug tracking-ds-snug', props.class)">
    <slot />
  </p>
</template>
